import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import cookie from "js-cookie";
import ExportJsonExcel from "js-export-excel";
import { DatePicker } from "react-advance-jalaali-datepicker";
import moment from "moment";
import categoryUserSitePublisherAction from "../../../store/actions/categoryUserSitePublisher";
import messageCategoryUserSitePublishers from "../../../messages/category-user-site-publishers";
import helperSpinner from "../../../helpers/spinner";
import helpersNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import typeActionCategoryUserSitePublisher from "../../../store/actions/typeActionCategoryUserSitePublisher";
import actionCookie from "../../../helpers/action-cookie";
import UserExample from "../user/UserExample";
import ButtonDisable from "../../partials/other/ButtonDisable";
import ListSitePublisher from "./ListSitePublisher";
import CategorySitePublisherTopic from "./CategorySitePublisherTopic";
import ExportFileExcelButton from "./ExportFileExcelButton";
import PreviewPositionsGroupSitePublisher from "./PreviewPositionsGroupSitePublisher";

function AddGroupSitePublisher({
  dataSitePublisher,
  render,
  emptyPositions,
  setDates,
  startDate,
  endDate,
  nameCategory,
  resetDate,
  setTypeAction,
}) {
  const checkSitePublisherThatHasUserCategory = (
    userCategory,
    sitePublisherCategories
  ) => {
    if (sitePublisherCategories.includes(userCategory)) {
      return true;
    }
    return false;
  };

  const removeSitePublisherThatHasUserCategory = (listSitePublisher) => {
    return listSitePublisher.filter((sitePublisher) => {
      if (
        !checkSitePublisherThatHasUserCategory(
          UserExample.category,
          sitePublisher.categories
        )
      ) {
        return sitePublisher;
      }
    });
  };

  const [sitePublishers, setSitePublishers] = useState(() => {
    return removeSitePublisherThatHasUserCategory(ListSitePublisher);
  });

  const [searchInputText, setSearchInputText] = useState("");
  const [categorySitePublisherSelected, setCategorySitePublisherSelected] =
    useState(0);

  const [
    editDateCategoryUserSitePublisher,
    setEditDateCategoryUserSitePublisher,
  ] = useState(false);

  useEffect(() => {
    setSitePublishers(
      removeSitePublisherThatHasUserCategory(getSitePublisherFromSearchInputs())
    );
  }, [searchInputText, categorySitePublisherSelected]);

  const getSitePublisherFromSearchInputs = () => {
    const sitePublisherThatHasSearchURL = getSitePublisherThatHasSearchURL();
    const sitePublisherThatHasCategorySelected =
      getSitePublisherThatHasCategorySelected();

    const sitePublisherSearch = [];
    for (const sitePublisherThatHasSearchURLItem of sitePublisherThatHasSearchURL) {
      for (const sitePublisherThatHasCategorySelectedItem of sitePublisherThatHasCategorySelected) {
        if (
          sitePublisherThatHasSearchURLItem.id ==
          sitePublisherThatHasCategorySelectedItem.id
        ) {
          sitePublisherSearch.push(sitePublisherThatHasSearchURLItem);
        }
      }
    }

    return sitePublisherSearch;
  };

  const getSitePublisherThatHasCategorySelected = () => {
    if (categorySitePublisherSelected == "0") {
      return ListSitePublisher;
    }
    return ListSitePublisher.filter((sitePublisher) => {
      if (sitePublisher.categories.includes(categorySitePublisherSelected)) {
        return sitePublisher;
      }
    });
  };

  const getSitePublisherThatHasSearchURL = () => {
    return ListSitePublisher.filter((sitePublisher) => {
      if (sitePublisher.url.includes(searchInputText)) {
        return sitePublisher;
      }
    });
  };

  const generateTagSitesPublisher = () => {
    if (!sitePublishers.length) {
      return (
        <tr>
          <td
            colSpan={5}
            style={{ borderBottomRightRadius: "25px" }}
            className="text-center"
          >
            هیچ سایتی با این مشخصات موجود نیست.
          </td>
        </tr>
      );
    }
    return sitePublishers.map((sitePublisher, index) => {
      return (
        <tr key={index}>
          <td>{helpersNumbers.toPersianNum(index + 1)}</td>
          <td>
            <a href={sitePublisher.url} target="_blank">
              {sitePublisher.url}
            </a>
          </td>
          <td>{sitePublisher.categories.join(" - ")}</td>
          <td>
            <div className="d-flex justify-content-around">
              <span>
                <i className="fa fa-mobile-alt"></i>
              </span>
              <span>
                <i className="fa fa-desktop"></i>
              </span>
            </div>
          </td>
          <td>
            <Link
              to={`/publishers/${sitePublisher.id}/all-page`}
              className="btn btn-info"
            >
              نمایش صفحات
            </Link>
          </td>
        </tr>
      );
    });
  };

  const [message, setMessage] = useState();

  const previousPageUrl = cookie.get(actionCookie.PREVIOUS_PAGE_URL);

  const checkPreviousPageUrlIsAllPageSitePublishers = () => {
    if (
      previousPageUrl.includes("/publishers") &&
      previousPageUrl.includes("/all-page")
    ) {
      return true;
    }
    return false;
  };
  const [isShowWebSite, setIsShowWebSite] = useState(() => {
    if (!checkPreviousPageUrlIsAllPageSitePublishers()) {
      startDate = null;
      endDate = null;
    }
    if (startDate !== null && endDate !== null) {
      return true;
    }
    return false;
  });
  if (!startDate) {
    startDate = moment(helpersTime.getDateNow())
      .add(1, "days")
      .format("YYYY/M/D");
  }

  if (!endDate) {
    endDate = moment(helpersTime.getDateNow())
      .add(2, "days")
      .format("YYYY/M/D");
  }

  setTypeAction({
    type_action: typeActionCategoryUserSitePublisher.ADD,
  });

  const generateCategorySitePublisherTopic = () => {
    return CategorySitePublisherTopic.map((category) => {
      if (category.id != UserExample.category_id) {
        return <option>{category.title}</option>;
      }
    });
  };

  let messageTag;
  if (message) {
    messageTag = (
      <div key={Math.random()} className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    if (!checkPreviousPageUrlIsAllPageSitePublishers()) {
      resetDate();
      emptyPositions();
    }
  }, []);

  const exportReportExcel = () => {
    const newDataSitePublisher = { ...dataSitePublisher };
    var option = new Object();
    const categoryUserSitePublisher = document
      .querySelector("#name")
      .value.trim();
    option.fileName =
      categoryUserSitePublisher == ""
        ? "گزارش سایت های انتخاب شده"
        : categoryUserSitePublisher;
    let dataExcelFile = [
      {
        one: "مبلغ گروه نمایش دهنده",
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(
            getPriceCategoryUserSitePublisher(newDataSitePublisher)
          )
        ),
      },
      {
        one: "تاریخ شروع",
        two: helpersNumbers.toPersianNum(startDate),
        three: "تاریخ پایان",
        four: helpersNumbers.toPersianNum(endDate),
      },
      {
        one: "=======================",
        two: "=======================",
      },
    ];

    for (let key in newDataSitePublisher) {
      dataExcelFile = [
        ...dataExcelFile,
        ...generateEachSitePublisherArrayReportExportExcel(
          newDataSitePublisher[key]
        ),
        {
          one: "=======================",
          two: "=======================",
        },
      ];
    }

    option.datas = [
      {
        sheetData: dataExcelFile,
        columnWidths: [10, 10],
      },
    ];

    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
    dataExcelFile = [];
  };

  const generateEachSitePublisherArrayReportExportExcel = (
    sitePublisherDataParam
  ) => {
    let sitePublisherUrl = sitePublisherDataParam.url;

    let dataEachSitePublisherExcelFile = [
      {
        one: sitePublisherUrl,
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(
            getPriceSitePublisher(sitePublisherDataParam)
          )
        ),
      },
    ];

    for (const key in sitePublisherDataParam) {
      if (key === "url") {
        continue;
      }

      const item = sitePublisherDataParam[key];
      dataEachSitePublisherExcelFile = [
        ...dataEachSitePublisherExcelFile,
        ...generatePageDataReportExportExcel(item),
      ];
    }

    return dataEachSitePublisherExcelFile;
  };

  const generatePageDataReportExportExcel = (pageDataReport) => {
    return [
      {
        one: pageDataReport.title,
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(pageDataReport.price)
        ),
      },
      { ...pageDataReport.positions },
      { one: "", two: "" },
    ];
  };

  const getPriceSitePublisher = (priceSitePublisher) => {
    let pricePage = 0;
    const newSitePublisherData = { ...priceSitePublisher };
    for (const key in newSitePublisherData) {
      if (key === "url") {
        continue;
      }
      pricePage = pricePage + newSitePublisherData[key].price;
    }
    return pricePage;
  };

  const getPriceCategoryUserSitePublisher = (sitePublisherData) => {
    let priceCategoryUserSitePublisher = 0;
    for (let key in sitePublisherData) {
      priceCategoryUserSitePublisher += getPriceSitePublisher(
        sitePublisherData[key]
      );
    }
    return priceCategoryUserSitePublisher;
  };

  const checkStartDateEntered = (startDateEntered) => {
    startDateEntered = helpersTime.convertJalaliToGregorian(startDateEntered);
    if (moment(startDateEntered).diff(startDate, "d") < 0) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.START_DATE_IS_PAST_FROM_CURRENT_DATE,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    let currentDate = moment(new Date().toISOString().split("T")[0]);
    const differentDates = moment(startDateEntered).diff(currentDate, "days");
    let maxCountDaysCategoryUserSitePublisherForStartDate =
      parseInt(
        process.env.REACT_APP_MAX_COUNT_DAYS_CATEGORY_USER_SITE_PUBLISHER
      ) - 1;
    if (differentDates > maxCountDaysCategoryUserSitePublisherForStartDate) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.START_DATE_IS_TOO_MUCH,
        class_icon: "fa fa-exclamation-triangle",
      });

      return false;
    }

    return true;
  };

  const checkEndDateEntered = (endDateEntered, startDateEntered) => {
    endDateEntered = helpersTime.convertJalaliToGregorian(endDateEntered);

    if (moment(endDateEntered).diff(endDate, "d") < 0) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.END_DATE_IS_PAST_FROM_START_DATE,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    if (
      moment(endDateEntered).diff(
        moment(helpersTime.convertJalaliToGregorian(startDateEntered)),
        "d"
      ) < 0
    ) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.END_DATE_IS_PAST_FROM_START_DATE,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    let currentDate = moment(new Date().toISOString().split("T")[0]);
    const differentDates = moment(endDateEntered).diff(currentDate, "days");
    if (
      differentDates >
      parseInt(
        process.env.REACT_APP_MAX_COUNT_DAYS_CATEGORY_USER_SITE_PUBLISHER
      )
    ) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.END_DATE_IS_TOO_MUCH,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    return true;
  };

  const generateTableEditDateCategoryUserSitePublisher = () => {
    return (
      <div className="col-12">
        <div className="table-responsive pt-3">
          <table className="table table-hilite">
            <thead>
              <tr>
                <td className="text-nowrap">
                  ارزش یک شبانه روز گروه نمایش دهنده{" "}
                </td>
                <td>تاریخ شروع </td>
                <td>تاریخ پایان </td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span className="px-2 letter-spacing-finance-number">
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(
                        getPriceCategoryUserSitePublisher(dataSitePublisher)
                      )
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
                <td>
                  <span className="number-finance">
                    {helpersNumbers.toPersianNum(startDate)}
                  </span>
                </td>
                <td>
                  <span className="number-finance">
                    {helpersNumbers.toPersianNum(endDate)}
                  </span>
                </td>
                <td>
                  <span>
                    <span
                      className="btn btn-danger"
                      onClick={() => {
                        setEditDateCategoryUserSitePublisher(false);
                        setIsShowWebSite(true);
                      }}
                    >
                      انصراف از ویرایش تاریخ شروع و پایان و نمایش سایت ها{" "}
                    </span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const showWebSites = () => {
    const startDateEntered = document.querySelector(".start-date input").value;
    const endDateEntered = document.querySelector(".end-date input").value;
    const nameCategory = document.querySelector("#name").value.trim();

    if (!nameCategory) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.NAME_DOSE_NOT_EXIST,
        class_icon: "fa fa-exclamation-triangle",
      });
      helperSpinner.scrollForSeeMessage(".card");
      return;
    }

    if (editDateCategoryUserSitePublisher) {
      startDate = helpersTime.convertJalaliToGregorian(startDate);
      endDate = helpersTime.convertJalaliToGregorian(endDate);
    }

    if (!checkStartDateEntered(startDateEntered)) {
      helperSpinner.scrollForSeeMessage(".card");
      return;
    }
    if (!checkEndDateEntered(endDateEntered, startDateEntered)) {
      helperSpinner.scrollForSeeMessage(".card");
      return;
    }

    setDates({
      name_category: nameCategory,
      start_date: startDateEntered,
      end_date: endDateEntered,
    });
    setIsShowWebSite(true);
    if (editDateCategoryUserSitePublisher) {
      setEditDateCategoryUserSitePublisher(false);
      emptyPositions();
    }
  };

  const generateSitePublisher = () => {
    return (
      <div className={`container-fluid p-0 ${isShowWebSite ? "" : "d-none"} `}>
        <div className="row">
          <div className="col-12 col-md-6">
            <div>
              <label>جستجو آدرس سایت</label>
            </div>
            <div>
              <input
                className="form-control"
                id="site"
                type="text"
                onKeyUp={(e) => {
                  setSearchInputText(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div>
              <div>
                <label>انتخاب دسته بندی موضوع</label>
              </div>
              <div>
                <select
                  id="categories-site-publishers"
                  className="form-control"
                  onChange={(e) => {
                    setCategorySitePublisherSelected(e.target.value);
                  }}
                >
                  <option value="0"> همه دسته بندی ها</option>
                  {generateCategorySitePublisherTopic()}
                </select>
              </div>
            </div>
          </div>

          <div className="col-12  ">
            <div className="table-responsive pt-3">
              <table className="table table-hilite tbl-td-white-space table-hover">
                <thead>
                  <tr>
                    <td>#</td>
                    <td>نمایش دهنده</td>
                    <td>دسته بندی موضوع</td>
                    <td>قابل نمایش در</td>
                    <td>نمایش صفحات</td>
                  </tr>
                </thead>
                <tbody>{generateTagSitesPublisher()}</tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="col-12 pt-2">
          <div className="form-group">
            <ButtonDisable
              buttonTagHtml={
                <span className="btn btn-success opacity-50">اضافه کردن</span>
              }
            />
          </div>
        </div>
      </div>
    );
  };

  const generateMessageBox = () => {
    return (
      <div className="alert alert-warning">
        <p className="text-justify">
          <i className="fa fa-info pl-2"></i>
          توجه داشته باشید :{" "}
        </p>
        <ul className="pr-3">
          <li>
            <p className="text-justify">
              ساعت تاریخ شروع از ۰۰:۰۰ و ساعت تاریخ پایان از ۲۳:۵۹
            </p>
          </li>
          <li>
            <p className="text-justify">
              {" "}
              به طور مثال : تاریخ شروع ۰۰:۰۰ ۱۴۰۰/۴/۲ و تاریخ پایان ۲۳:۵۹
              ۱۴۰۰/۴/۲۰
            </p>
          </li>
          <li>
            <p className="text-justify">
              تاریخ شروع گروه بنری سایت های نمایش دهنده شما باید در بازه یک روز
              بعد از تاریخ جاری تا ۸۹ روز بعد
            </p>
          </li>
          <li>
            <p className="text-justify">
              تاریخ پایان گروه بنری سایت های نمایش دهنده شما باید در بازه دو روز
              بعد از تاریخ جاری تا ۹۰ روز بعد باشد
            </p>
          </li>
          <li>
            <p className="text-justify">به طور مثال : تاریخ جاری ۱۴۰۰/۷/۱</p>
          </li>
          <li>
            <p className="text-justify">
              بازه مجاز برای تاریخ شروع ۱۴۰۰/۷/۲ - ۱۴۰۰/۹/۲۹- دو روز ۷/۲ و ۹/۲۹
              جزیی از این بازه هستن که ۸۹ روز میشود
            </p>
          </li>
          <li>
            <p className="text-justify">
              بازه مجاز برای تاریخ پایان ۱۴۰۰/۷/۳ - ۱۴۰۰/۱۰/۲- دو روز ۷/۳ و ۱۰/۲
              جزیی از این بازه هستن که ۹۰ روز میشود
            </p>
          </li>
          <li>
            <p className="text-justify">
              توجه داشته باشید که ۶ ماه ابتدا سال ۳۱ روزه و اسفند ماه ۲۹ روز
              است.
            </p>
          </li>
          <li>
            <p className="text-justify">
              قبل از اضافه کردن گروه , حتما به وسیله دکمه خروجی فایل Excel یک
              گزارش از سایت ها , صفحات , جایگاه های تبلیغاتی انتخاب شده بگیرید.
            </p>
          </li>
        </ul>
      </div>
    );
  };

  return (
    <>
      {messageTag}
      {generateMessageBox()}
      <form>
        <div className="form-group">
          <label>نام گروه</label>
          <input
            type="text"
            className="form-control"
            placeholder="نام گروه"
            id="name"
            defaultValue={nameCategory != null ? nameCategory : ""}
            required
          />
        </div>

        <div className="form-group">
          <div className="container-fluid p-0">
            <div className="row align-items-end">
              {isShowWebSite ? (
                <div className="col-12">
                  <div className="table-responsive pt-3">
                    <table className="table table-hilite">
                      <thead>
                        <tr>
                          <td className="text-nowrap">
                            ارزش یک شبانه روز گروه نمایش دهنده{" "}
                          </td>
                          <td>تاریخ شروع </td>
                          <td>تاریخ پایان </td>
                          <td>عملیات</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <span className="px-2 letter-spacing-finance-number">
                              {helpersNumbers.toPersianNum(
                                helpersNumbers.toFormatFinanceNumber(
                                  getPriceCategoryUserSitePublisher(
                                    dataSitePublisher
                                  )
                                )
                              )}
                            </span>
                            <span className="pr-2">تومان</span>
                          </td>
                          <td>
                            <span className="number-finance">
                              {helpersNumbers.toPersianNum(startDate)}
                            </span>
                          </td>
                          <td>
                            <span className="number-finance">
                              {helpersNumbers.toPersianNum(endDate)}
                            </span>
                          </td>
                          <td>
                            {editDateCategoryUserSitePublisher ? (
                              <span>
                                <span
                                  className="btn btn-danger"
                                  onClick={() => {
                                    setEditDateCategoryUserSitePublisher(false);
                                    setIsShowWebSite(true);
                                  }}
                                >
                                  انصراف از ویرایش تاریخ شروع و پایان و نمایش
                                  سایت ها{" "}
                                </span>
                              </span>
                            ) : (
                              <span>
                                <span
                                  className="btn btn-success"
                                  onClick={() => {
                                    setEditDateCategoryUserSitePublisher(true);
                                    setIsShowWebSite(false);
                                  }}
                                >
                                  ویرایش تاریخ شروع و تاریخ پایان
                                </span>
                              </span>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <>
                  {editDateCategoryUserSitePublisher && (
                    <div className="alert alert-warning w-100">
                      <p className="text-justify">
                        <i className="fa fa-info pl-2"></i>
                        توجه داشته باشید :{" "}
                      </p>
                      <ul className="pr-3">
                        <li>
                          <p className="text-justify">
                            در صورت ویرایش تاریخ شروع و پایان جایگاه های از قبل
                            ایجاد شده حذف شده
                          </p>
                        </li>
                      </ul>
                    </div>
                  )}

                  <div className="col-12 col-md-4 pb-3">
                    <div>
                      <div>
                        <label>تاریخ شروع</label>
                      </div>
                      <div className="custom-data-picker start-date">
                        <DatePicker
                          placeholder="انتخاب تاریخ"
                          format="jYYYY/jMM/jDD"
                          preSelected={
                            editDateCategoryUserSitePublisher
                              ? startDate
                              : helpersTime.convertGregorianToJalali(startDate)
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-4 pb-3">
                    <div>
                      <div>
                        <label>تاریخ پایان</label>
                      </div>
                      <div className="custom-data-picker end-date">
                        <DatePicker
                          placeholder="انتخاب تاریخ"
                          format="jYYYY/jMM/jDD"
                          preSelected={
                            editDateCategoryUserSitePublisher
                              ? endDate
                              : helpersTime.convertGregorianToJalali(endDate)
                          }
                        />
                        {/* {isShowWebSite ? (
                          <></>
                        ) : (
                          <DatePicker
                            placeholder="انتخاب تاریخ"
                            format="jYYYY/jMM/jDD"
                            preSelected={helpersTime.convertGregorianToJalali(
                              endDate
                            )}
                          />
                        )} */}
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div className="col-12 col-md-4 pb-3">
                {isShowWebSite ? (
                  <></>
                ) : (
                  <button
                    className="btn btn-success w-100"
                    onClick={(e) => {
                      e.preventDefault();
                      showWebSites();
                    }}
                    disabled={isShowWebSite ? "disabled" : ""}
                  >
                    اعمال تاریخ و نمایش سایت ها
                  </button>
                )}
              </div>
            </div>
          </div>

          {editDateCategoryUserSitePublisher &&
            generateTableEditDateCategoryUserSitePublisher()}

          {isShowWebSite && generateSitePublisher()}
        </div>
      </form>

      <ExportFileExcelButton />
      <PreviewPositionsGroupSitePublisher />
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    dataSitePublisher: state.categoryUserSitePublisher.data_site_publisher,
    render: state.categoryUserSitePublisher.render,
    nameCategory: state.categoryUserSitePublisher.name_category,
    startDate: state.categoryUserSitePublisher.start_date,
    endDate: state.categoryUserSitePublisher.end_date,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    emptyPositions: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.EMPTY_POSITION,
        payload: action,
      });
    },
    setDates: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.SET_DATE,
        payload: action,
      });
    },
    setTypeAction: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.SET_TYPE_ACTION,
        payload: action,
      });
    },
    resetDate: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.RESET_DATE,
        payload: action,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddGroupSitePublisher);
